import SunbitApi from './SunbitApi';

// mock api wil be in CI env or in dev using cypress query parmas
// const queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
// export const isMockApi = CARD_ENV === 'ci' || (CARD_ENV === 'dev' && queryParams.cypress === 'true');
const sunbitApi = new SunbitApi();
export default sunbitApi;
